import React from 'react';

const Plus = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 2V18" stroke="white" strokeWidth="2" />
    <path d="M10 2V18" stroke="url(#paint0_linear_12590_845)" strokeOpacity="0.8" strokeWidth="2" />
    <path d="M18 10L2 10" stroke="white" strokeWidth="2" />
    <path
      d="M18 10L2 10"
      stroke="url(#paint1_linear_12590_845)"
      strokeOpacity="0.8"
      strokeWidth="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12590_845"
        x1="9.81512"
        y1="26"
        x2="25.8151"
        y2="10.3698"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EED7F1" />
        <stop offset="0.084745" stopColor="#FEFCFE" />
        <stop offset="0.191502" stopColor="#DBC1D4" />
        <stop offset="0.285358" stopColor="#6DD2E5" />
        <stop offset="0.400018" stopColor="#7BA0EB" />
        <stop offset="0.509667" stopColor="#BC86F6" />
        <stop offset="0.631842" stopColor="#DCC4F8" />
        <stop offset="0.747457" stopColor="#BFB5C6" />
        <stop offset="0.870443" stopColor="#F5F4F6" />
        <stop offset="1" stopColor="#D7CACE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12590_845"
        x1="-6"
        y1="9.81512"
        x2="9.63024"
        y2="25.8151"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EED7F1" />
        <stop offset="0.084745" stopColor="#FEFCFE" />
        <stop offset="0.191502" stopColor="#DBC1D4" />
        <stop offset="0.285358" stopColor="#6DD2E5" />
        <stop offset="0.400018" stopColor="#7BA0EB" />
        <stop offset="0.509667" stopColor="#BC86F6" />
        <stop offset="0.631842" stopColor="#DCC4F8" />
        <stop offset="0.747457" stopColor="#BFB5C6" />
        <stop offset="0.870443" stopColor="#F5F4F6" />
        <stop offset="1" stopColor="#D7CACE" />
      </linearGradient>
    </defs>
  </svg>
));

Plus.displayName = 'Plus';

export default Plus;
